import React from 'react';

export default function QuienesSomos() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-6">¿Quiénes somos?</h1>

      <p className="text-center text-gray-700 text-lg mb-10">
        Somos una startup de tecnología médica comprometida con mejorar la calidad de vida de las personas
        a través de soluciones inteligentes e innovadoras. Nuestra misión es acercar el monitoreo de salud
        a todos, desde casa.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <img src="/assets/equipo.jpg" alt="Nuestro equipo" className="rounded shadow" />
        <div>
          <h2 className="text-2xl font-semibold mb-4">Nuestra visión</h2>
          <p className="text-gray-600 mb-4">
            Visualizamos un futuro donde cualquier persona pueda tener acceso a herramientas de salud
            accesibles, precisas y no invasivas desde su ropa. Creemos que la prevención es el mejor tratamiento.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Nuestro equipo</h2>
          <p className="text-gray-600">
            Somos un grupo multidisciplinario de ingenieros, médicos, diseñadores y desarrolladores que comparten una misma pasión:
            innovar para cuidar a quienes más lo necesitan.
          </p>
        </div>
      </div>
    </div>
  );
}
